<template>
  <div class="retrieve-home">
    <div class="search-bar">
      <retrieve-search-bar
        @search="handleSearch"
        :double-search="doubleSearch"
        @myDoubleSearch="handleDoubleSearch"
      ></retrieve-search-bar>
    </div>
    <div class="content">
      <div class="side-bar">
        <RetrieveLeftMenu ref="leftMenu"></RetrieveLeftMenu>
      </div>
      <div class="main-content">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import RetrieveSearchBar from '@/components/RetrieveSearchBar.vue'
import RetrieveLeftMenu from '@/components/RetrieveLeftMenu.vue'
import BookCarouselContent from '../../components/BookCarouselContent.vue'
import RetrieveIntroduction from './RetrieveIntroduction.vue'
export default {
  name: 'RetrieveHome',
  components: {
    RetrieveSearchBar,
    RetrieveLeftMenu,
    BookCarouselContent,
    RetrieveIntroduction
  },
  data () {
    return {
      sideBarInfo: {},
      currentSearchText: '',
      doubleSearch: false
    }
  },
  mounted () {
  },
  methods: {
    handleSearch (searchText, command, exactSearch) {
      this.$refs.leftMenu.resetSideBar()
      this.doubleSearch = true
      this.currentSearchText = searchText
      this.$router.push({
        path: '/retrieve/retrieveHome/retrieveResult',
        query: {
          searchText: searchText,
          command: command,
          exactSearch: exactSearch ? 1 : 0
        }
      })
    },
    handleDoubleSearch (searchText, command, exactSearch) {
      if (searchText !== '') {
        this.$refs.leftMenu.resetSideBar()
        this.doubleSearch = true
        if (this.currentSearchText === '') {
          this.currentSearchText = searchText
        } else {
          this.currentSearchText += '+' + searchText
        }
        this.$router.push({
          path: '/retrieve/retrievehome/retrieveResult',
          query: {
            searchText: this.currentSearchText,
            command: command,
            exactSearch: exactSearch ? 1 : 0
          }
        })
      }
    }
  },
  watch: {
    '$route' (to, from) {
      if (to.path === '/retrieve/retrieveHome/introduction') {
        this.doubleSearch = false
        this.currentSearchText = ''
      }
    }
  }
}
</script>

<style scoped>
.retrieve-home {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.search-bar {
  position: relative;
  margin: 0 auto;
  margin-top: -50px;
  width: 1200px;
  background-color: rgba(158, 92, 29, 0.05);
  border-radius: 0px 0px 0px 0px;
}

.content {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
}

.side-bar {
  width: 220px;
  height: 810px;
  background-color: #fff;
  margin: 0;
  margin-right: 30px;
}

.main-content {
  margin: 0;
  width: 910px;
  height: 760px;
  background-color: #fff;
  padding-left: 20px;
  padding-top: 10px;
  padding-right: 20px;
  padding-bottom: 40px;
  overflow-y: scroll;
}

::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

::-webkit-scrollbar-track {
  border-radius: 3px;
  background: rgba(0, 0, 0, 0.06);
}
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background: rgba(158, 92, 29, 0.2);
}

.icon-title {
  display: flex;
  align-items: center;
  justify-content: left;
  border-bottom: 1px solid #9e5c1d;
  width: 156px;
  height: 50px;
  font-size: 18px;
  font-weight: bold;
  color: #9e5c1d;
}

.icon {
  width: 34px;
  margin-right: 10px;
}

.recommand-book {
  width: 880px;
  margin: 0 auto;
}

.recommand-book >>> .book-cards {
  width: 120px;
}

.recommand-book >>> .arrow {
  width: 37px;
  height: 37px;
}

.recommand-book >>> .book-title {
  margin-top: 0;
  margin-bottom: 7px;
  font-size: 16px;
  color: #634c37;
}

.introduction-text {
  width: 845px;
  margin: 0 auto;
  line-height: 36px;
  margin-top: 20px;
  margin-bottom: 20px;
  font-size: 16px;
  color: #634c37;
  text-align: left;
}

.introduction-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.introduction-list li {
  margin: 0;
  padding: 0;
  margin-bottom: 10px;
  font-size: 16px;
  color: #634c37;
  text-align: left;
}

.introduction-list li::before {
  content: " ";
  width: 8px;
  height: 8px;
  display: inline-block;
  background-color: #9e5c1d;
  transform: rotate(45deg);
  margin-right: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/retrieve/RetrieveHome.vue